// tempexp_18907-full-file
import { DebugLogger } from 'lib/debugLogger';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { discountInOutlowDebug } from 'reactApp/appHelpers/featuresHelpers/features/discountInOutflow';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { getTimeToDate, secondsToDays } from 'reactApp/utils/timeHelpers';

export const DISCOUNT_IN_OUTFLOW = 'discount-in-outflow';
export const DISCOUNT_IN_OUTFLOW_TIMER = 'discount-in-outflow-timer';
export const DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO = 'discount-in-outflow-last-day-promo';
export const RADAR_NAME = 'mnz_discount_after_unsubscribing';
export const discountInOutflowTypedRadarName = (type) => `${RADAR_NAME}_${type}`;

export const discountInOutflowLogger = new DebugLogger({ DEBUG_SCOPE: 'DiscountInOutflow', DEBUG: discountInOutlowDebug });

export const discountInOutflowTextFormatter = new Intl.NumberFormat('ru');

export const DISCOUNT_IN_OUTFLOW_PERIODS_TABLE = {
    '1m': 'в мес',
    '3m': 'на 3 мес',
    '6m': 'на 6 мес',
    '1y': 'в год',
    '2y': 'на 2 года',
};

export interface DiscountInOutflowLSData {
    subId: string;
    expirationDate: number;
    originalPrice: number;
    period: string;
    discountPrice?: number;
}

export const clearDiscountInOtflow = () => {
    discountInOutflowLogger.info('clear LS');
    storeHelper.clearStore(DISCOUNT_IN_OUTFLOW);
    storeHelper.clearStore(DISCOUNT_IN_OUTFLOW_TIMER);
    storeHelper.clearStore(DISCOUNT_IN_OUTFLOW_LAST_DAY_PROMO);
    emitAnalyticEvent(AnalyticEventNames.DISCOUNT_LS_CLEAR);
};

export const getDiscountRemainingDays = () => {
    const discountFlagValue = storeHelper.getValue(DISCOUNT_IN_OUTFLOW);
    if (!discountFlagValue) {
        return undefined;
    }
    const expirationDate = new Date(discountFlagValue.expirationDate);
    const remainingSeconds = getTimeToDate(expirationDate) / 1000;
    const remainingDaysExact = secondsToDays(remainingSeconds);
    return remainingDaysExact < 1 ? 0 : Math.ceil(remainingDaysExact);
};
